/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
    LinkToJSONTyped,
} from './Link';

/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    tenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    description?: string;
    /**
     * 
     * @type {Array<Link>}
     * @memberof Resource
     */
    rlinks?: Array<Link>;
}

/**
 * Check if a given object implements the Resource interface.
 */
export function instanceOfResource(value: object): value is Resource {
    return true;
}

export function ResourceFromJSON(json: any): Resource {
    return ResourceFromJSONTyped(json, false);
}

export function ResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Resource {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'rlinks': json['rlinks'] == null ? undefined : ((json['rlinks'] as Array<any>).map(LinkFromJSON)),
    };
}

export function ResourceToJSON(json: any): Resource {
    return ResourceToJSONTyped(json, false);
}

export function ResourceToJSONTyped(value?: Resource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'title': value['title'],
        'description': value['description'],
        'rlinks': value['rlinks'] == null ? undefined : ((value['rlinks'] as Array<any>).map(LinkToJSON)),
    };
}

